import { render } from "./Repackage_products.vue?vue&type=template&id=a289d602"
import script from "./Repackage_products.vue?vue&type=script&lang=js"
export * from "./Repackage_products.vue?vue&type=script&lang=js"

import "./Repackage_products.vue?vue&type=style&index=0&id=a289d602&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__